import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AuthShell, GoogleButton, AuthField, AuthError } from "../components/AuthShell";
import { formatApiErrorDetail } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    setLoading(true);
    try {
      await register(email.trim(), password, name.trim());
      navigate("/start");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Try UC Engineer Pro Free" subtitle="Create your private workspace in seconds.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <GoogleButton label="Sign up with Google" />
        <div className="flex items-center gap-3 text-[11px] uppercase tracking-widest text-zinc-600">
          <div className="h-px flex-1 bg-zinc-800" /> or <div className="h-px flex-1 bg-zinc-800" />
        </div>
        <AuthError message={error} />
        <AuthField label="Full name" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Jane Engineer" data-testid="register-name" />
        <AuthField label="Work email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" data-testid="register-email" />
        <AuthField label="Password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" data-testid="register-password" />
        <button type="submit" disabled={loading} data-testid="register-submit" className="w-full h-11 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-sm font-semibold text-white flex items-center justify-center gap-2 transition-colors">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Create account
        </button>
        <p className="text-[11px] text-zinc-500 text-center">By continuing you agree to our terms. No credit card required.</p>
      </form>
      <p className="mt-6 text-sm text-zinc-400 text-center">
        Already have an account?{" "}
        <Link to="/login" className="text-blue-400 hover:text-blue-300 font-medium" data-testid="go-login">Sign in</Link>
      </p>
    </AuthShell>
  );
}
